module.exports = __webpack_public_path__ + "static/media/to.f68fa7f7.svg";